import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import {
    Badge,
    Button,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Input,
    Table
} from "reactstrap";
import VWPagination from "../../components/vwPagination/vwPagination";
import NoRecord from "../../components/NoRecords/noRecords";
import VWLoading from "../../components/vwLoading/vwLoading";
import Skeleton from "../../components/vwSkeleton/vwSkeleton"
import { getPager } from "../../helper/common";
import { CUSTOMER, SUPER_ADMIN } from "../../store/users/role.constants";
import Message from "../../CommonData/Data/Message";
import moment from 'moment';
import VWModel from "../../components/vwModal/vwModal";
import {
    closeReturnRequestsActionModal,
    getReturnRequestsList,
    openReturnRequestsActionModal,
    setPageSizeGlobalRequest
} from "../../store/returnRequests/actions";
import AddReturnRequest from "./AddReturnRequest";
import debounce from "lodash/debounce";
import { STATUS_LIST } from "../../store/device/actionTypes";
import UITooltip from "../../CommonData/Data/UITooltip";
import Async from "react-select/async";
import { getReasonForAsyncSelect } from "../../store/returnRequests/actions";

const style = {
    table: {
        width: '100%',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'separate',
    },
    th: {
        top: 0,
        left: 0,
        zIndex: 2,
        position: 'sticky',
        backgroundColor: '#fff',
    },
};

const customStyles = {
    container: (provided) => ({
        ...provided,
        fontWeight: 'normal',
    }),
    control: (provided) => ({
        ...provided,
        fontWeight: 'normal',
        minWidth: '230px',
        minHeight: "30px",
        height: "30px",
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: "2px 8px",
        height: "30px",
    }),
    option: (provided, state) => ({
        ...provided,
        fontWeight: 'normal'
    }),
    input: (provided) => ({
        ...provided,
        margin: "0px",
        padding: "0px",
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: "14px",
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: "30px",
    }),
};

const ReturnRequestsList = (props) => {
    const { returnRequests, isGetReturnApprovalsPending, isReturnRequestsActionModalOpen, errorMessage, currentProfile } = props;
    const [pageSize, setPageSize] = useState(10);
    const [pager, setPager] = useState({ currentPage: 1 });
    const [filter, setFilter] = useState({ requestStatus: "All" });
    const [filterDisplay, setFilterDisplay] = useState();

    const isSuperAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
        (currentProfile.roles[0].roleKey === SUPER_ADMIN);
    const isEndUser = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === CUSTOMER;

    //-----------------------FILTER------------------------------------------------
    const buildQueryDeviceKey = () => {
        const { deviceKey } = filter || {};
        let searchDeviceKey = '';
        if (deviceKey) {
            searchDeviceKey += `${deviceKey}`;
        }
        return searchDeviceKey
    }

    const buildQueryRequestStatus = () => {
        const { requestStatus } = filter || {};
        let searchRequestStatus = '';
        if (requestStatus !== "All" && requestStatus) {
            searchRequestStatus += `${requestStatus}`;
        }
        // else if (requestStatus) {
        //     searchRequestStatus += `${requestStatus}`;
        // }
        return searchRequestStatus
    }

    const buildQueryRequestCreatedTimeStamp = () => {
        const { requestCreatedTimeStamp } = filter || {};
        let searchRequestCreatedTimeStamp = '';
        if (requestCreatedTimeStamp) {
            searchRequestCreatedTimeStamp += `${requestCreatedTimeStamp}`;
        }
        return searchRequestCreatedTimeStamp
    }

    const buildQueryRequestedTo = () => {
        const { requestedTo } = filter || {};
        let searchRequestedTo = '';
        if (requestedTo) {
            searchRequestedTo += `${requestedTo}`;
        }
        return searchRequestedTo
    }

    const buildQueryRequestReason = () => {
        const { requestReason } = filter || {};
        let searchRequestReason = '';
        if (requestReason) {
            searchRequestReason += `${requestReason}`;
        }
        return searchRequestReason
    }

    const buildQueryRequestNotes = () => {
        const { requestNotes } = filter || {};
        let searchRequestNotes = '';
        if (requestNotes) {
            searchRequestNotes += `${requestNotes}`;
        }
        return searchRequestNotes
    }

    const buildQueryStatusUpdatedTieStamp = () => {
        const { statusUpdatedTieStamp } = filter || {};
        let searchStatusUpdatedTieStamp = '';
        if (statusUpdatedTieStamp) {
            searchStatusUpdatedTieStamp += `${statusUpdatedTieStamp}`;
        }
        return searchStatusUpdatedTieStamp
    }
    const buildQueryStatusUpdatedReason = () => {
        const { statusUpdatedReason } = filter || {};
        let searchStatusUpdatedReason = '';
        if (statusUpdatedReason) {
            searchStatusUpdatedReason += `${statusUpdatedReason}`;
        }
        return searchStatusUpdatedReason
    }

    const setPage = (page = 1) => {
        props.getReturnRequestsList(page, pageSize, buildQueryDeviceKey(), buildQueryRequestStatus(), buildQueryRequestCreatedTimeStamp(), buildQueryRequestedTo(),
            buildQueryRequestReason(), buildQueryRequestNotes(), buildQueryStatusUpdatedTieStamp(), buildQueryStatusUpdatedReason(), sortDirection, sortOrder);
        setPager(prevPager => {
            const totalPages = Math.ceil(props.totalRecords / pageSize);
            const visiblePages = 10;
            const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
            const newPages = [];
            for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
                newPages.push(i);
            }
            return {
                ...prevPager,
                currentPage: page,
                totalPages,
                pages: newPages,
            };
        });
    };
    useEffect(() => {
        const currentUpdatePager = getPager(props.totalRecords, 1, pageSize);
        setPager(currentUpdatePager);
    }, [props.totalRecords, pageSize]);

    useEffect(() => {
        setPage();
        props.setPageSizeGlobalRequest(pageSize)
    }, [pageSize])

    const sendBackendRequest = useCallback((name, value) => {
        setFilter((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }, []);

    const debouncedSendRequest = useMemo(() => {
        return debounce(sendBackendRequest, 1000);
    }, [sendBackendRequest]);

    const searchInputValidation = (event) => {
        const input = event.target;
        const { value, name } = input;
        debouncedSendRequest(name, value)
        setFilterDisplay({
            ...filterDisplay,
            [name]: value
        });
    }

    const handleLoadReason = (inputValue, callback) => {
        props.getReasonForAsyncSelect(inputValue, callback);
    };

    const handleAddReasonFilter = (option) => {
        const { label, value } = option || {};
        debouncedSendRequest("requestReason", label);
        setFilterDisplay({
            ...filterDisplay,
            requestReason: label,
            requestReasonId: value
        });
    }
    const handleSearchClick = () => {
        setPage();
    };

    const handleKeypress = (e) => {
        if (e.key === 'Enter') {
            handleSearchClick();
        }
    };

    useEffect(() => {
        if (filter) {
            handleSearchClick();
        }
    }, [filter])

    //----------------------SORTING-------------------------------------
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortOrder, setSortOrder] = useState(null);

    const handleSort = (column) => {
        if (sortOrder === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortOrder(column);
            setSortDirection('asc');
        }
    };
    useEffect(() => {
        if (sortOrder && sortDirection) {
            setPage();
        }
    }, [sortOrder, sortDirection])

    //----------------------ADD REQUEST-------------------------------------
    const handleOpenAddRequestAction = () => {
        props.openReturnRequestsActionModal();
    };

    const handleClose = () => {
        props.closeReturnRequestsActionModal();
    };

    return (
        <div className="page-content">
            <Card>
                <CardTitle className="p-2 mb-0 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold">
                    RETURN REQUESTS LIST
                    <div className="d-flex gap-4 content-heading">
                        <Button size="sm" color="primary" onClick={handleOpenAddRequestAction}>
                            <i className="fas fa-people-carry"></i>  Add Return
                        </Button>
                    </div>
                </CardTitle>
            </Card>
            <Card>
                <CardBody>
                    {errorMessage && (
                        <Message
                            type="danger"
                            defaultMessage={errorMessage}
                            baseClassName="alert"
                        />
                    )}
                    <div style={{ maxHeight: "500px", overflowX: "auto" }}>
                        <Table className="table table-striped table-hover w-100" size="sm" style={style.table}>
                            <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: "10" }}>
                                <tr className="text-nowrap">
                                    <th style={{ maxWidth: "300px" }}>
                                        SERIAL #
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('requestStatus')}>
                                        RETURN STATUS
                                        {sortOrder === 'requestStatus' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('requestCreatedTimeStamp')}>
                                        RETURN INITIATED ON
                                        {sortOrder === 'requestCreatedTimeStamp' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('requestedToDisplayName')}>
                                        RETURNED TO
                                        {sortOrder === 'requestedToDisplayName' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('requestReason')}>
                                        REASON
                                        {sortOrder === 'requestReason' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer", maxWidth: "200px" }} onClick={() => handleSort('requestNotes')}>
                                        NOTES
                                        {sortOrder === 'requestNotes' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    {/* <th style={{ cursor: "pointer" }} onClick={() => handleSort('statusUpdatedTieStamp')}>
                                        APPROVED / REJECTED ON
                                        {sortOrder === 'statusUpdatedTieStamp' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('statusUpdatedReason')}>
                                        APPROVAL / REJECTION REASON
                                        {sortOrder === 'statusUpdatedReason' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th> */}
                                </tr>
                                <tr>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='number'
                                                size='sm'
                                                placeholder="Search"
                                                name="deviceKey"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.deviceKey) || ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='select'
                                                size='sm'
                                                placeholder="Search"
                                                name="requestStatus"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.requestStatus) || ""}
                                                disabled
                                            >
                                                {/* <option value={"All"}>All</option> */}
                                                <option value={"Submitted"}>Submitted</option>
                                                <option value={"Approved"}>Approved</option>
                                                <option value={"rejected"}>Rejected</option>
                                            </Input>
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='date'
                                                size='sm'
                                                placeholder="Search"
                                                name="requestCreatedTimeStamp"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.requestCreatedTimeStamp) || ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='text'
                                                size='sm'
                                                placeholder="Search"
                                                name="requestedTo"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.requestedTo) || ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Async
                                                styles={{ ...customStyles, menuPortal: base => ({ ...base, zIndex: 10 }) }}
                                                placeHolder="Search"
                                                name="requestReason"
                                                defaultOptions
                                                menuPortalTarget={document.body}
                                                isClearable
                                                loadOptions={handleLoadReason}
                                                onChange={handleAddReasonFilter}
                                                onKeyPress={handleKeypress}
                                                value={filterDisplay && filterDisplay.requestReason ? { label: filterDisplay.requestReason, value: filterDisplay.requestReasonId } : ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='text'
                                                size='sm'
                                                placeholder="Search"
                                                name="requestNotes"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.requestNotes) || ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    {/* <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='date'
                                                size='sm'
                                                placeholder="Search"
                                                name="statusUpdatedTieStamp"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.statusUpdatedTieStamp) || ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='text'
                                                size='sm'
                                                placeholder="Search"
                                                name="statusUpdatedReason"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.statusUpdatedReason) || ""}
                                            />
                                        </FormGroup>
                                    </th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {(returnRequests && returnRequests.length > 0) && !isGetReturnApprovalsPending ?
                                    returnRequests.map((data, index) => (
                                        <tr key={index}>
                                            <td>{data.deviceList && data.deviceList.map((i) => {
                                                return (
                                                    <UITooltip
                                                        content={
                                                            <>
                                                                <div>
                                                                    Name: {i.name || "NA"}
                                                                    &nbsp;<sup>
                                                                        <Badge color='primary'>
                                                                            {i.deviceTypeFlag}
                                                                        </Badge>
                                                                    </sup>
                                                                </div>
                                                                {isEndUser &&
                                                                    <>
                                                                        <div>Room Name: {i.roomName || "NA"}</div>
                                                                        <div>Friendly Name: {i.friendlyName || "NA"}</div>
                                                                    </>
                                                                }
                                                                <div>   Status: {i.isActive ? (
                                                                    <Badge color="success">Active</Badge>
                                                                ) : (<Badge color="danger">Inactive</Badge>)}
                                                                </div>
                                                            </>
                                                        }
                                                        id={`deviceDetails-${i.deviceId}`}
                                                    >
                                                        <Badge className="fs-6 p-2 me-2 mb-2" color="info" pill style={{ cursor: "pointer" }}>
                                                            {i.deviceKey}
                                                        </Badge>
                                                    </UITooltip>
                                                )
                                            })}
                                            </td>
                                            <td>{data.requestStatus || "NA"}</td>
                                            <td>{data.requestCreatedTimeStamp ? moment(data.requestCreatedTimeStamp).format("DD MMM YYYY") : "NA"}</td>
                                            <td>
                                                {data.requestedToDisplayName || "NA"} {`(${data.requestedToUserRole})`}<br />
                                                <small>{data.requestedToEmail}</small>
                                            </td>
                                            <td>{data.requestReason || "NA"}</td>
                                            <td>{data.requestNotes || "NA"}</td>
                                            {/* <td>{data.statusUpdatedTieStamp ? moment(data.statusUpdatedTieStamp).format("DD MMM YYYY") : "NA"}</td>
                                            <td>{data.statusUpdatedReason || "NA"}</td> */}
                                        </tr>
                                    ))
                                    : isGetReturnApprovalsPending ? (
                                        <tr>
                                            <td colSpan={9} align="center" className="p-4">
                                                <Skeleton type="body" />
                                                <VWLoading />
                                            </td>
                                        </tr>
                                    ) :
                                        <tr>
                                            <td colSpan={9}>
                                                <NoRecord />
                                            </td>
                                        </tr>
                                } </tbody>
                        </Table>
                    </div >
                </CardBody>
                <CardFooter>
                    {returnRequests.length > 0 ?
                        <VWPagination
                            pager={pager}
                            setPage={setPage}
                            totalRecords={props.totalRecords}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                        /> : null
                    }
                </CardFooter>
            </Card>
            <VWModel
                header="ADD RETURN REQUEST"
                isOpen={isReturnRequestsActionModalOpen}
                handleClose={handleClose}
            >
                <AddReturnRequest
                    handleClose={handleClose}
                />
            </VWModel>
        </div>
    )
}

const mapStateToProps = (state) => ({
    isReturnRequestsActionModalOpen: state.returnRequests.isReturnRequestsActionModalOpen,
    returnRequests: state.returnRequests.returnRequests,
    errorMessage: state.returnRequests.returnRequestsListError,
    totalRecords: state.returnRequests.totalRecords,
    isGetReturnRequestsPending: state.returnRequests.isGetReturnRequestsPending,
    currentProfile: state.login.currentProfile,
});

const mapDispatchToProps = (dispatch) => ({
    openReturnRequestsActionModal: () => dispatch(openReturnRequestsActionModal()),
    closeReturnRequestsActionModal: () => dispatch(closeReturnRequestsActionModal()),
    setPageSizeGlobalRequest: (pageSize) => dispatch(setPageSizeGlobalRequest(pageSize)),
    getReturnRequestsList: (page, pageSize, searchDeviceKey, searchRequestStatus, searchRequestCreatedTimeStamp, searchRequestedTo, searchRequestReason, searchRequestNotes,
        searchStatusUpdatedTieStamp, searchStatusUpdatedReason, sortDirection, sortOrder) => dispatch(getReturnRequestsList(page, pageSize, searchDeviceKey, searchRequestStatus,
            searchRequestCreatedTimeStamp, searchRequestedTo, searchRequestReason, searchRequestNotes, searchStatusUpdatedTieStamp, searchStatusUpdatedReason, sortDirection, sortOrder)),
    getReasonForAsyncSelect: (inputValue, callback) => dispatch(getReasonForAsyncSelect(inputValue, callback))
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnRequestsList);